<template>
  <div class="text-center white--text mb-4">
    <!--    <span class="display-3 font-weight-light mb-4">{{appName}}</span>-->
    <v-row justify="center">
      <v-img
          max-height="150"
          max-width="250"
          src="/lessadmin.png"
      ></v-img>
    </v-row>

  </div>
</template>

<script>
export default {
  name: "Header",
  data: function() {
    return {
      appName: "Less Admin"
    };
  }
};
</script>